import { Box, Theme, withStyles } from '@material-ui/core';
import FsHeaderSmall from 'ui-elements/typography/FsHeaderSmall';
import FsBodyExtraSmall from 'ui-elements/typography/FsBodyExtraSmall';

export const Value = withStyles(() => ({
  root: {
    fontWeight: 400,
  },
}))(FsHeaderSmall);

export const RowBox = withStyles(
  ({ spacing, palette, breakpoints }: Theme) => ({
    root: {
      borderRadius: spacing(1),
      backgroundColor: palette.grey[100],
      padding: spacing(1, 2),
      [breakpoints.up('sm')]: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      },
    },
  })
)(Box);

export const HeaderBox = withStyles(({ breakpoints }: Theme) => ({
  root: {
    [breakpoints.up('sm')]: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
}))(Box);

export const ValueBox = withStyles(({ breakpoints }: Theme) => ({
  root: {
    display: 'none',
    [breakpoints.up('sm')]: {
      display: 'block',
    },
  },
}))(Box);

export const NameContainerBox = withStyles(
  ({ palette, spacing, breakpoints }: Theme) => ({
    root: {
      [breakpoints.up('sm')]: {
        borderLeft: `1px solid ${palette.grey[200]}`,
        paddingLeft: spacing(2),
        marginLeft: spacing(2),
      },
    },
  })
)(Box);

export const CategoryLabel = withStyles(
  ({ palette, spacing, breakpoints }: Theme) => ({
    root: {
      display: 'none',
      [breakpoints.up('sm')]: {
        display: 'block',
        color: palette.grey[300],
        marginRight: spacing(0.4),
      },
    },
  })
)(FsBodyExtraSmall);

export const Category = withStyles(({ palette, spacing }: Theme) => ({
  root: {
    color: palette.common.black,
    marginLeft: spacing(0.2),
  },
}))(FsBodyExtraSmall);
